import React from 'react'
import {
    faNewspaper,
    faAnglesRight,
    faCheck,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SectionHeading from '../Common/SectionHeading';

export default function ContentSection({ data }) {
    const coverage = data?.coverage
    return (
        <>
            <div className=''>
                <SectionHeading
                    title={data?.title}
                    customClass='text-left'
                />
                <div className='dark:text-white' dangerouslySetInnerHTML={{ __html: data?.description }}></div>
                {coverage?.length > 0 ? <><h3 className='my-2 text-lg font-semibold text-black'>Know More About Whats Covered:</h3>
                    <ul className='m-4'>
                        {coverage?.map((cov, index) => (
                            <li key={index} className="flex text-base">
                                <div className="pr-4">
                                    <FontAwesomeIcon style={{ color: '#1b5df3', marginRight: '5px' }} icon={faCheck} />
                                </div>
                                {cov.value}
                            </li>
                        ))}
                    </ul></> : null}
            </div>
        </>
    )
}
